import { useCallback } from 'react'

import { useAuthUserUpdates } from '~/hooks/useAuthUser'
import { useServerRequests } from '~/hooks/useRequests'
import { UserFlagKey, UserFlags } from '~/types'

export const useUserFlag = () => {
  const { serverPutRequest } = useServerRequests()
  const { updateUserFlags } = useAuthUserUpdates()

  return useCallback(
    async (key: UserFlagKey) => {
      const response = await serverPutRequest<UserFlags>({
        path: '/api/user/edit/flags',
        params: { key },
        errorMessage: '',
      })

      if (response) {
        updateUserFlags(response.data)
      }
    },
    [serverPutRequest, updateUserFlags],
  )
}
